export const lockBodyScroll = (): (() => void) => {
  const prevOverflow = document.body.style.overflow;
  document.body.style.overflow = 'hidden';

  return () => {
    document.body.style.overflow = prevOverflow;
  };
};
